import { motion } from "framer-motion";
import React, { MouseEventHandler } from "react";

import "./HalfScreenPanel.css";

type HalfScreenPanelProps = {
  children: React.ReactChild;
  onClose: MouseEventHandler<HTMLDivElement>;
};

const HalfScreenPanel = ({ children, onClose }: HalfScreenPanelProps) => {
  return (
    <>
      <div className="HalfScreen__cancelScreen" onClick={onClose} />
      <motion.div
        className="HalfScreen"
        initial={{ x: "100%" }}
        animate={{ x: "0" }}
        exit={{ x: "100%" }}
        transition={{ ease: "anticipate" }}
      >
        {children}
      </motion.div>
    </>
  );
};

export default HalfScreenPanel;
